import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/vps-hosting-contents/TopicOne";

const VPSHostingContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Optimized for Professional and Automated Traders</h2>
                <p>
                  The Pips VPS Hosting service offers lightning-fast execution
                  and 24/7 connectivity, ensuring your trading strategies never
                  pause, even when your device is offline. Hosted on high-speed
                  servers close to major financial hubs, our VPS environment
                  minimizes latency, safeguards data, and provides seamless
                  access to MetaTrader platforms anytime, anywhere. It’s built
                  to support expert advisors, algorithmic systems, and
                  high-frequency setups with maximum stability. With
                  uninterrupted performance and enterprise-grade security, your
                  trading operations stay efficient, protected, and always one
                  step ahead.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Request VPS Access
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/vps_hosting/vps_hosting_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VPSHostingContentOne;
